export default __webpack_public_path__ + "static/media/PricingBasicLandscape.79650c85.png";